/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StepIdentifier } from './StepIdentifier';
import {
    StepIdentifierFromJSON,
    StepIdentifierFromJSONTyped,
    StepIdentifierToJSON,
    StepIdentifierToJSONTyped,
} from './StepIdentifier';
import type { StepStatus } from './StepStatus';
import {
    StepStatusFromJSON,
    StepStatusFromJSONTyped,
    StepStatusToJSON,
    StepStatusToJSONTyped,
} from './StepStatus';
import type { SubscriptionStepDataDto } from './SubscriptionStepDataDto';
import {
    SubscriptionStepDataDtoFromJSON,
    SubscriptionStepDataDtoFromJSONTyped,
    SubscriptionStepDataDtoToJSON,
    SubscriptionStepDataDtoToJSONTyped,
} from './SubscriptionStepDataDto';

/**
 * Represents a subscription process step
 * @export
 * @interface SubscriptionStepDto
 */
export interface SubscriptionStepDto {
    /**
     * Unique identifier of the step
     * @type {number}
     * @memberof SubscriptionStepDto
     */
    id: number;
    /**
     * 
     * @type {StepIdentifier}
     * @memberof SubscriptionStepDto
     */
    identifier: StepIdentifier;
    /**
     * i18n key for the step name.
     * Frontend should use this with translation namespace (e.g., COMMON.LABELS.FOLDER_CREATION).
     * 
     * @type {string}
     * @memberof SubscriptionStepDto
     */
    name: string;
    /**
     * 
     * @type {StepStatus}
     * @memberof SubscriptionStepDto
     */
    status: StepStatus;
    /**
     * 
     * @type {SubscriptionStepDataDto}
     * @memberof SubscriptionStepDto
     */
    data?: SubscriptionStepDataDto;
    /**
     * Sub-steps within this step (same structure, recursive)
     * @type {Array<SubscriptionStepDto>}
     * @memberof SubscriptionStepDto
     */
    subSteps: Array<SubscriptionStepDto>;
}



/**
 * Check if a given object implements the SubscriptionStepDto interface.
 */
export function instanceOfSubscriptionStepDto(value: object): value is SubscriptionStepDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('identifier' in value) || value['identifier'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('subSteps' in value) || value['subSteps'] === undefined) return false;
    return true;
}

export function SubscriptionStepDtoFromJSON(json: any): SubscriptionStepDto {
    return SubscriptionStepDtoFromJSONTyped(json, false);
}

export function SubscriptionStepDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionStepDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'identifier': StepIdentifierFromJSON(json['identifier']),
        'name': json['name'],
        'status': StepStatusFromJSON(json['status']),
        'data': json['data'] == null ? undefined : SubscriptionStepDataDtoFromJSON(json['data']),
        'subSteps': ((json['subSteps'] as Array<any>).map(SubscriptionStepDtoFromJSON)),
    };
}

export function SubscriptionStepDtoToJSON(json: any): SubscriptionStepDto {
    return SubscriptionStepDtoToJSONTyped(json, false);
}

export function SubscriptionStepDtoToJSONTyped(value?: SubscriptionStepDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'identifier': StepIdentifierToJSON(value['identifier']),
        'name': value['name'],
        'status': StepStatusToJSON(value['status']),
        'data': SubscriptionStepDataDtoToJSON(value['data']),
        'subSteps': ((value['subSteps'] as Array<any>).map(SubscriptionStepDtoToJSON)),
    };
}

